module.exports = __webpack_public_path__ + "fonts/WorkSans-Bold.189a3716.otf";